<template>
    <div>
        <sign-up></sign-up>
    </div>
</template>

<script>
import SignUp from '../components/auth/SignUp.vue'

export default {
    components: {
        SignUp
    },
}
</script>